(function () {
var $694623aef831c635$exports = {};
(function() {
    window.addEventListener("load", (event)=>{
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://sdk.onfido.com/v14.24.0";
        document.body.appendChild(script);
    });
})();

})();
//# sourceMappingURL=index.b22a76b2.js.map
